import { get as get_data } from 'data/data';import { get as _get_reservation } from 'data/reservation';
import { get as _get_trip } from 'data/tour-vessel';
import { send_confirmation_email } from 'data/notification';
import { get_all as get_booking_settings } from 'data/booking_setting';

import { get as get_cache } from 'utils/cache';
import { convertISOtoDate } from 'utils/date';
import { strip_tags, esc_html } from 'utils/strings';
import Cookies from 'js-cookie'

import { 
    EMAIL_THIS_PAGE, 
    COMPLETE_PAGE_TOUR, 
    COMPLETE_PAGE_GC,
    PAGE_ERROR, 
    MODAL_TEMPLATE, 
} from 'booking-widget/v1/common/templates';

import { show_loading, hide_loading } from 'ui/visibility';
import { init as setup_modal, show as show_modal } from 'ui/modal';

import { exclusion_string } from 'booking-widget/v1/common/util';

export const init = (options) => {
    if (!options) {
        options = {};
    }

    let opts = $.extend({
        context_el: $('body'),
        on_init: function() {},
        maintenance_message: false
    }, options);

    let el = opts.context_el;
    let transaction_info = Cookies.get('ca-transaction');
    if (transaction_info) {
        transaction_info = JSON.parse(transaction_info);
    }
    
    el.empty().addClass('bw bw-confirmation bw-ca');

    if (!transaction_info || !transaction_info.reservation_id) {
        display_page_error('No Reservation Found', 'Please make sure you have the correct URL.')
        return;
    }

    show_loading($('body'));
    $.when(get_reservation(transaction_info.reservation_id), get_trip(transaction_info.reservation_id), get_booking_settings({data: {tour_id: transaction_info.tour_id} }))
        .then(function(res_json, trip_json, booking_setttings_json) {
            if (res_json.success == false || trip_json.success == false) {
                display_page_error('Error', 'Reservation not found or has past.');
                hide_loading($('body'));
                return;
            }
            if (res_json.data.reservation_type == 'Gift') {
                render_page_gc(res_json.data, transaction_info);
            }
            else {
                render_page(res_json.data, trip_json.data[0], transaction_info);
            }

            opts.on_init(transaction_info);

            hide_loading($('body'));
        }, function() {
            hide_loading($('body'));
        })
    ;
    
    $(document).on('bw-maintenance-error', function(e, params) {
        let error = opts.maintenance_message ? opts.maintenance_message : params.error;
        if (!el.hasClass('bw--maintenance-mode')) {
            el.addClass('bw--maintenance-mode').empty();
            setup_modal({
                html: MODAL_TEMPLATE.replace(/\[modal_id\]/g, 'maintenance-modal'),
                on_shown: function(e, params) {
                    $('.bw-modal__content', '#maintenance-modal').text(error);
                }
            });
            show_modal($('#maintenance-modal'));
        }
    });

    function display_page_error(title, message) {
        el.append(PAGE_ERROR
            .replace(/\[error_title\]/g, title)
            .replace(/\[error_message\]/g, message)
        );
    }

    function get_reservation(id) {
        return _get_reservation({
            id: id,
            fields: 'number,reservation_type,is_paid',
        });
    }

    function get_trip(reservation_id) {
        return _get_trip({
            filters: 'reservation.id.eq(' + reservation_id + ')',
            fields: 'start_time,vessel.toddlers_allowed,vessel.pregnant_allowed,tour.checkin_minutes,tour.res_complete_partial,tour.embed_video_url,tour.embed_video2_url,location.name,location.map_uri',
            expand: 'vessel,tour,reservation,location'
        });
    }

    function render_page_gc(data, transaction_info) {
        let payment_info_html = '';

        if (transaction_info && transaction_info.payment_amount) {
            payment_info_html += '$' + Number(transaction_info.payment_amount).toFixed(2);

            if (transaction_info.cc_last4) {
                payment_info_html += ' charged to card -' + transaction_info.cc_last4;
                if (transaction_info.payment_created_time) {
                    // in US so it's consistent with the email
                    let payment_date_string = (new Date(transaction_info.payment_created_time)).toLocaleDateString('en-US', { 
                        day: 'numeric', 
                        month: 'numeric', 
                        year:'numeric', 
                    });;
                    payment_info_html += ' on ' + payment_date_string;
                }
                payment_info_html += ' from "Captain Andy\'s Sailing Inc."'
            }
        }

        let expires = new Date();
        expires.setFullYear(expires.getFullYear() + 5);

        let expires_str = expires.toLocaleDateString('en-US', { 
            day: 'numeric', 
            month: 'numeric', 
            year:'numeric'
        });


        el.append(COMPLETE_PAGE_GC
            .replace(/\[\[gc_code\]\]/g, data.number)
            .replace(/\[\[gc_value\]\]/g, Number(transaction_info.payment_amount).toFixed(2))
            .replace(/\[\[payment_info\]\]/g, payment_info_html)
            .replace(/\[\[expires\]\]/g, expires_str)
            .replace(/\[\[purchaser_name\]\]/g, transaction_info.name)
        );

        opts.on_init();
    }

    function render_page(res_data, trip_data, transaction_info) {
        let tour = trip_data.tour[0];
        let trip = trip_data;
        let vessel = trip_data.vessel[0];
        let start_date = convertISOtoDate(trip.start_time);
        let start_date_string = start_date.toLocaleDateString('en-US', { 
            day: 'numeric', 
            month: 'numeric', 
            year:'numeric', 
            weekday:'long' 
        });
        let time_string = start_date.toLocaleTimeString('en-US', {
            hour:'numeric', 
            minute:'2-digit'
        });
        
        let payment_info_html = '';
        let passenger_summary = '';
        if (transaction_info) {
            if (transaction_info.passenger_counts) {
                let pax_counts = transaction_info.passenger_counts;
                passenger_summary = pax_counts.adult + ' Adult' + (pax_counts.adult != 1 ? 's' : '');
                if (pax_counts.child > 0) {
                    passenger_summary += ', ' + pax_counts.child + ' Child' + (pax_counts.child != 1 ? 'ren' : '');
                }
                for (let val in pax_counts.food_prefs) {
                    let food_count = pax_counts.food_prefs[val];
                    if (food_count > 0) {
                        passenger_summary += '<br>' + food_count + ' ' + val.toLowerCase()  + ' meal(s)';
                    }
                }
            }

            if (transaction_info.payment_amount) {
                payment_info_html += '$' + Number(transaction_info.payment_amount).toFixed(2);

                if (transaction_info.cc_last4) {
                    payment_info_html += ' charged to card -' + transaction_info.cc_last4;
                    if (transaction_info.payment_created_time) {
                        // in US so it's consistent with the email
                        let payment_date_string = (new Date(transaction_info.payment_created_time)).toLocaleDateString('en-US', { 
                            day: 'numeric', 
                            month: 'numeric', 
                            year:'numeric', 
                        });;
                        payment_info_html += ' on ' + payment_date_string;
                    }
                    payment_info_html += ' from "Captain Andy\'s Sailing Inc."'
                }
            }
        }

        if (payment_info_html == '') {
            // include some kind of payment info
            if (res_data.is_paid == 1) {
                payment_info_html += '<span class="green">Paid in full</span>';
            }
            else {
                payment_info_html += '<span class="bw-red">Requires additional payment.  Please contact the reservation desk.</span>';
            }
        }
        payment_info_html += '<br>';

        let restrictions = exclusion_string(vessel.toddlers_allowed, vessel.pregnant_allowed).toLowerCase();
        restrictions = '<p>We are ' + restrictions + '</p>';

        let checkin_location = '';
        if (trip_data.location) {
            let location = trip_data.location[0];
            if (location.map_uri && location.map_uri != '') {
                checkin_location = '<a href="' + encodeURI(location.map_uri) + '" target="_blank">' + esc_html(location.name) + '</a>';
            }
            else {
                checkin_location = esc_html(location.name);
            }
        }

        el.append(COMPLETE_PAGE_TOUR
            .replace(/\[\[tour_name\]\]/g, (transaction_info && transaction_info.tour_name) ? esc_html(transaction_info.tour_name) : '')
            .replace(/\[\[email\]\]/g, (transaction_info && transaction_info.email) ? esc_html(transaction_info.email) : '')
            .replace(/\[\[tour_start_date\]\]/g, esc_html(start_date_string + ' @ ' + time_string))
            .replace(/\[\[tour_checkin_minutes\]\]/g, esc_html(tour.checkin_minutes))
            .replace(/\[\[reservation_number\]\]/g, esc_html(res_data.number))
            .replace(/\[\[payment_info\]\]/g, payment_info_html)
            .replace(/\[\[tour_video_url\]\]/g, encodeURI(tour.embed_video_url))
            .replace(/\[\[tour_res_complete_partial\]\]/g, strip_tags(tour.res_complete_partial, '<button><div><span><p><a><strong><i>'))
            .replace(/\[\[restrictions\]\]/g, restrictions)
            .replace(/\[\[passenger_summary\]\]/g, strip_tags(passenger_summary, '<button><div><span><p><a><strong><i>'))
            .replace(/\[\[checkin_location\]\]/g, checkin_location)
        );

        el.append(EMAIL_THIS_PAGE);
        
        $('form[class="bw-email-form"]', el).on('submit', function(e) {
            e.preventDefault();
            let form_el = $(this);
            let input_el = $('input[name="emails"]', form_el);
            show_loading(form_el);
            send_confirmation_email({
                data: {
                    emails: input_el.val(),
                    reservation_id: transaction_info.reservation_id
                },
                on_done: function(json) {
                    hide_loading(form_el);
                    input_el.val('');
                    if (json.success) {
                        $('.bw-email-form-message', el)
                            .removeClass('bw-red')
                            .addClass('bw-green')
                            .text('Emails sent successfully')
                        ;
                    }
                    else {
                        $('.bw-email-form-message', el)
                            .removeClass('bw-green')
                            .addClass('bw-red')
                            .text('Emails failed to send, please check your email addresses and try again.')
                        ;
                    }
                }
            });
            return false;
        });
    }
}